if (typeof YT == 'undefined' || typeof YT.Player == 'undefined') {
    const tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    const firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

let player;
window.onYouTubeIframeAPIReady = () => {
    player = new YT.Player('VideoBlock', {
        events: {
            onReady: onPlayerReady
        }
    });
};

window.onPlayerReady = (event) => {
    // Add a custom play/pause button
    let playButton = document.querySelector('.video-block__cover-play');
    playButton.addEventListener('click', (e) => {
        e.currentTarget.parentNode.classList.add('video-block__video--playing');
        player.playVideo();
    });
};
